export const blockStyle = {
  gap: "0px",
};

export const numberStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "13px",
  height: "24px",
}

export const parentStyle = {
  width: "32px",
  height: "36px",
};